import { Icon } from "@shopify/polaris"
import { PageDownMajor } from "@shopify/polaris-icons"
import React from "react"
import { useTranslation } from "react-i18next"

export const CSVDownloadButton = ({ csvDownloadUrl, csvFilename }) => {
	const { t } = useTranslation()

	if (!csvDownloadUrl) return ""

	return (
		<div
			style={{
				marginTop: "2rem",
				display: "flex",
				justifyContent: "center",
			}}
		>
			<a
				style={{ textDecoration: "none" }}
				href={csvDownloadUrl}
				download={csvFilename}
				title={csvFilename}
			>
				<div className="home-button" style={{ width: "16rem" }}>
					<div style={{ width: "15%" }}>
						<Icon source={PageDownMajor} color="base" />
					</div>
					<p style={{ fontSize: "1.2rem", color: "#454F5B" }}>
						{t("common.download_csv_file")}
					</p>
				</div>
			</a>
		</div>
	)
}
